import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { Observable } from "rxjs";
import { filter, map, take } from "rxjs/operators";

import { UserRoles } from "../../../definitions/user-roles";
import { AppState } from "../../../store/reducers";
import { SelectUser } from "../../../store/selectors/user.selectors";

@Injectable()
export class ProductAdminGuard {
	constructor(private store: Store<AppState>) {}

	canActivate(): Observable<boolean> {
		return this.store.select(SelectUser).pipe(
			filter((state) => state.auth === true),
			take(1),
			map((userState) => _.intersection(UserRoles.vendorRange.product, userState.roles).length > 0)
		);
	}
}
